import Button from "@mui/material/Button"; // MUI ICON COMPONENTS
import Typography from "@mui/material/Typography";

import Add from "@mui/icons-material/Add";
import Remove from "@mui/icons-material/Remove"; // GLOBAL CUSTOM COMPONENTS

import styled from "@mui/material/styles/styled";
import SalifyFallback from "src/lib/components/salify-fallback/default";
import { FlexBetween, FlexBox } from "../../salify-next-layout/default/components/flex-box"; // ==============================================================

const StyledInput = styled("input")(({ theme }) => ({
  paddingLeft: 8,
  paddingRight: 8,
  height: 36,
  textAlign: "center",
  border: "0.5px solid",
  borderColor: theme.palette.light.main,
  borderRadius: 8,
  "&:focus": {
    outline: "none",
  },
  marginLeft: 10,
  marginRight: 10,
}));

const QuantityButtons = ({ quantity, handleDecrement, handleIncrement, handleEdit }) => (
  <FlexBox flexDirection="column" gap={1}>
    <Typography color="dark.dark3">
      <SalifyFallback.Label path="Quantity" default="Số lượng" />
    </Typography>
    <FlexBox>
      <FlexBetween>
        <Button
          variant="outlined"
          onClick={handleIncrement}
          sx={{
            width: 36,
            height: 36,
            color: "dark.dark3",
            borderColor: "light.light0",
            borderRadius: "8px",
          }}
        >
          <Add fontSize="small" />
        </Button>

        <StyledInput size={2} value={quantity} onChange={handleEdit} />

        <Button
          variant="outlined"
          sx={{
            width: 36,
            height: 36,
            color: "dark.dark3",
            borderColor: "light.light0",
            borderRadius: "8px",
          }}
          onClick={handleDecrement}
        >
          <Remove fontSize="small" />
        </Button>
      </FlexBetween>
    </FlexBox>
  </FlexBox>
);

export default QuantityButtons;
